"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
// Boolean Formulae over Exp.
var ast_1 = require('./ast');
var BFml = (function () {
    function BFml() {
    }
    return BFml;
}());
exports.BFml = BFml;
var BExp = (function (_super) {
    __extends(BExp, _super);
    function BExp(exp) {
        _super.call(this);
        this.exp = exp;
    }
    BExp.prototype.normalize = function () {
        // 中身はnormalizeしないの？
        return new BExp(this.exp);
    };
    BExp.prototype.toString = function () {
        return this.exp.toLTL();
    };
    return BExp;
}(BFml));
exports.BExp = BExp;
var BConst = (function (_super) {
    __extends(BConst, _super);
    function BConst(value) {
        _super.call(this);
        this.value = value;
    }
    BConst.prototype.normalize = function () {
        return this;
    };
    BConst.prototype.toString = function () {
        return String(this.value);
    };
    return BConst;
}(BFml));
exports.BConst = BConst;
var BIn = (function (_super) {
    __extends(BIn, _super);
    function BIn(prop, neg) {
        _super.call(this);
        this.prop = prop;
        this.neg = neg;
    }
    BIn.prototype.normalize = function () {
        return this;
    };
    BIn.prototype.toString = function () {
        return '_ ' + (this.neg ? '\u2209 ' : '\u2208 ') + this.prop;
    };
    return BIn;
}(BFml));
exports.BIn = BIn;
var BOr = (function (_super) {
    __extends(BOr, _super);
    function BOr(op1, op2) {
        _super.call(this);
        this.op1 = op1;
        this.op2 = op2;
    }
    BOr.prototype.normalize = function () {
        var op1 = this.op1.normalize();
        var op2 = this.op2.normalize();
        if (op1 instanceof BConst) {
            return op1.value ? op1 : op2;
        }
        else if (op2 instanceof BConst) {
            return op2.value ? op2 : op1;
        }
        else {
            return new BOr(op1, op2);
        }
    };
    BOr.prototype.toString = function () {
        return ast_1.util.atom(this.op1.toString()) + ' /\\ ' + ast_1.util.atom(this.op2.toString());
    };
    return BOr;
}(BFml));
exports.BOr = BOr;
var BAnd = (function (_super) {
    __extends(BAnd, _super);
    function BAnd(op1, op2) {
        _super.call(this);
        this.op1 = op1;
        this.op2 = op2;
    }
    BAnd.prototype.normalize = function () {
        var op1 = this.op1.normalize();
        var op2 = this.op2.normalize();
        if (op1 instanceof BConst) {
            return op1.value ? op2 : op1;
        }
        else if (op2 instanceof BConst) {
            return op2.value ? op1 : op2;
        }
        else {
            return new BAnd(op1, op2);
        }
    };
    BAnd.prototype.toString = function () {
        return ast_1.util.atom(this.op1.toString()) + ' \\/ ' + ast_1.util.atom(this.op2.toString());
    };
    return BAnd;
}(BFml));
exports.BAnd = BAnd;



/*****************
 ** WEBPACK FOOTER
 ** ./dist/bfml.js
 ** module id = 25
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ./dist/bfml.js
 ** module id = 25
 ** module chunks = 1
 **/